import { Alert } from "../../../components/ui/Alert";

export function AlertCloseCycle({
  alertName,
  customer,
  isLoading = false,
  onConfirm,
}) {
  if (!customer?.pet?.subscription) return null;


  return (
    <Alert.Root name={alertName}>
      <Alert.Content>
        <Alert.Title>Encerrar ciclo</Alert.Title>
        <Alert.Description>
          <span>
            O pet <strong className="highlight">{customer.pet.name}</strong> ainda
            possui uma assinatura com ciclo ativo.
          </span>
          <span>
            Ao encerrar o ciclo agora, a assinatura será finalizada imediatamente.
          </span>
          <span>
            Essa ação é irreversível e permite seguir com a criação de uma nova assinatura.
          </span>
        </Alert.Description>
        <Alert.Actions>
          <Alert.Cancel disabled={isLoading}>Voltar</Alert.Cancel>
          <Alert.Confirm
            disabled={isLoading}
            isLoading={isLoading}
            onClick={onConfirm}
          >
            {isLoading ? "Encerrando ciclo..." : "Encerrar ciclo"}
          </Alert.Confirm>
        </Alert.Actions>
      </Alert.Content>
    </Alert.Root>
  );
}
